export default ({ text, color }) => ({
    title: {
        ...text.text_md,
        marginRight: 16,
        width: '150px',
        display: 'inline-block',
        height: '100%',
        marginTop: '16px',
        boxSizing: 'border-box',
    },
    inputStyle: {
        ...text.text_md,
        color: 'rgb(143, 143, 143)',
        width: 252,
    },
    hintStyle: {
        ...text.text_md_hint,
    },
    valueListTextMenu: {
        ...text.text_md,
    },
    selected: {
        ...text.text_md,
        display: 'inline-block',
        padding: '0px 5px 5px 0px',
        borderRadius: 16,
        color: 'white',
        backgroundColor: '#97a9b9',
        whiteSpace: 'nowrap',
        marginRight: 5,
        marginBottom: 5,
        // width:262,
        marginTop: 12,
        verticalAlign: 'top',
        height: 20,
    },

    fieldContainer: {
        minHeight: '44px',
        margin: '0 20px',
    },
    avatarRow: {
        marginTop: 10,
        marginRight: 10,
        float: 'left',
    },
    clearStyle: {
        margin: '1px 3px 0px 10px',
    },

    titleStyle: {
        maxWidth: 200,
        display: 'inline-block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },

    titleStyleOpportunity: {
        maxWidth: 200,
        display: 'inline-block',
        verticalAlign: 'middle',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        marginTop: -4,
        marginLeft: 0,
    },
    text: {
        ...text.text_md,
        color: 'rgb(143, 143, 143)',
        position: 'absolute !important',
        marginTop: '14px',
        marginLeft: '-5px',
    },
});
